module.exports = __webpack_public_path__ + "img/19ddbb6.png";